import { DateTime } from 'luxon'

import { LanguageResponseDTO } from '@/core/api/dtos/response/misc/language'
import { Language } from '@/core/api/entities/misc/language'
import { GenericMapper } from '@/core/api/mappers/genericMapper'

export class LanguageMapper {
	static toEntity(dto: LanguageResponseDTO): Language {
		const dates = GenericMapper.mapDates({
			createdAt: dto.created_at,
			updatedAt: dto.updated_at,
		})

		return new Language(
			dto.id,
			dto.name,
			dto.ietf,
			dto.active,
			dto.default,
			dates.createdAt ?? DateTime.now(),
			dates.updatedAt ?? DateTime.now()
		)
	}

	static toEntities(dtos: LanguageResponseDTO[]): Language[] {
		return dtos.map(this.toEntity)
	}
}
